import SupraLockbox from '@bb/domain/dist/types/SupraLockbox';
import Tag from 'components/Tag';
import React from 'react';
import styled from 'styled-components';

const LockboxLicenseTag: React.FC<{
  ownershipStatus?: SupraLockbox['ownershipStatus'];
  isLost?: boolean;
  isDefective?: boolean;
}> = ({ ownershipStatus, isLost, isDefective }) => {
  if (isLost) {
    return <StyledTag color="orange">Lost</StyledTag>;
  }

  if (isDefective) {
    return <StyledTag color="orange">Defective</StyledTag>;
  }

  if (ownershipStatus) {
    return (
      <StyledTag color={ownershipStatus === 'Purchased' ? 'green' : 'blue'}>
        {ownershipStatus}
      </StyledTag>
    );
  }

  return null;
};

const StyledTag = styled(Tag)`
  font-weight: 400;
`;

export default LockboxLicenseTag;
